import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClienteComboOutput, PedidoBaixaOnlineOutput, PedidoComentariosInput, PedidoComentariosOutput, PedidoConsultaOutput, PedidoDetalheOutput, PedidoIncluirComentarioInput, PedidoIncluirComentarioOutput, PedidoRatOutput } from 'src/app/@shared/models/consulta-detalhe';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class ConsultaDetalheService {

  constructor(private http: HttpClient) { }

  getClientesConsultaDetalhes(): Observable<ClienteComboOutput[]> {
    return this.http.get<ClienteComboOutput[]>(`ConsultaDetalhes/SelecionarClientes`, httpOptions);
  } 

  getConsultaDetalhadaPorNRT(pedidoid:any){
    return this.http.get<PedidoConsultaOutput[]>(`ConsultaDetalhes/SelecionarConsultaDetalhadaPorNRT/${pedidoid}`, httpOptions);
  }

  getConsultaDetalhadaPorConta(idConta:string, clienteId?:number){
    return this.http.get<PedidoConsultaOutput[]>(`ConsultaDetalhes/SelecionarConsultaDetalhadaPorConta/${idConta}/${clienteId || ""}`, httpOptions);
  }

  getConsultaDetalhadaPorCliente(codigoDeBarras:string, clienteId?:number){
    return this.http.get<PedidoConsultaOutput[]>(`ConsultaDetalhes/SelecionarConsultaDetalhadaPorCliente/${codigoDeBarras}/${clienteId}`, httpOptions);
  }

  getConsultaDetalhadaPorNumeroRastreio(idconta:string, clienteId?:number){
    return this.http.get<PedidoConsultaOutput[]>(`ConsultaDetalhes/SelecionarConsultaDetalhadaPorNumeroRastreio/${idconta}/${clienteId || ""}`, httpOptions);
  }

  getConsultaDetalhadaPorAgenciaConta(agencia:string,conta:string, clienteId?:number){
    return this.http.get<PedidoConsultaOutput[]>(`ConsultaDetalhes/SelecionarConsultaDetalhadaPorAgenciaConta/${agencia}/${conta}/${clienteId || ""}`, httpOptions);
  }

  getConsultaDetalhadaPorNFE(nfe:string, clienteId?:number){
    return this.http.get<PedidoConsultaOutput[]>(`ConsultaDetalhes/SelecionarConsultaDetalhadaPorNFE/${nfe}/${clienteId || ""}`, httpOptions);
  }

  getConsultaDetalhadaDadosGuia(pedidoid:number){
    return this.http.get<PedidoDetalheOutput>(`ConsultaDetalhes/SelecionarDadosGuia/${pedidoid}`, httpOptions);
  }

  getConsultaDetalhadaDadosRAT(pedidoid:number){
    return this.http.get<PedidoRatOutput[]>(`ConsultaDetalhes/SelecionarConsultaDetalhadaRAT/${pedidoid}`, httpOptions);
  }

  getConsultaDetalhadaDadosBaixaOnline(pedidoid:number){
    return this.http.get<PedidoBaixaOnlineOutput[]>(`ConsultaDetalhes/SelecionarDadosBaixaOnline/${pedidoid}`, httpOptions);
  }
  
  getConsultaDadosObsComentario(obj: PedidoComentariosInput): Observable<PedidoComentariosOutput[]> {
    return this.http.get<PedidoComentariosOutput[]>(
      `ConsultaDetalhes/SelecionarDadosObsComentario/${obj.pedidoId}`
      + `?paginaAtual=${obj.paginaAtual}&itensPorPAgina=${obj.itensPorPagina}`,
      httpOptions
      );
  }

  incluirPedidoObsComentario(obj: PedidoIncluirComentarioInput): Observable<PedidoIncluirComentarioOutput> {
    return this.http.post<PedidoIncluirComentarioOutput>(`ConsultaDetalhes/IncluirPedidoObsComentario`, obj, httpOptions);
  }
}